import { htmlE } from "/WebInterface/new-ui/assets/js/utils/te.js";

const TooltipTemplate = htmlE`
    <div class="is-absolute arrow ${"position"}"></div>
    <p class="text-tooltip-text text-sm">${"text"}</p>
`;

export default TooltipTemplate;
